@if (showSuperBanner()) {
  <div class="super-user-banner" role="alert" aria-live="polite">
    <i class="pi pi-shield" aria-hidden="true"></i>
    <span>{{ bannerText() }}</span>
  </div>
}

@if (showNav() | async) {
  <nav class="navbar">
    <div class="navbar-content">
      <!-- Left section: App home, Toggle Button, Logo, and Club Name -->
      <div class="navbar-left">
        @if (isAdminAppWebView()) {
          <button
            type="button"
            class="app-webview-home-btn"
            (click)="navigateHomeFromApp()"
            aria-label="Return to app home"
            title="Home"
          >
            <i class="pi pi-home" aria-hidden="true"></i>
          </button>
        }
        <!-- Desktop: Sidebar toggle button -->
        <button
          type="button"
          class="sidebar-toggle-btn desktop-only"
          (click)="toggleSidebarCollapse()"
          [attr.aria-label]="isSideNavCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
          [title]="isSideNavCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
        >
          <i class="fa-solid fa-bars" aria-hidden="true"></i>
        </button>
        <!-- Mobile: Hamburger button -->
        <button
          type="button"
          class="hamburger-btn mobile-only"
          [class.active]="isMobileNavOpen()"
          (click)="toggleSidebarCollapse()"
          aria-label="Toggle navigation menu"
        >
          <div class="hamburger-icon" aria-hidden="true">
            <span class="line line1"></span>
            <span class="line line2"></span>
            <span class="line line3"></span>
          </div>
        </button>
        <img class="navbar-logo" [src]="parentClubLogo()" alt="Club logo"
          referrerpolicy="no-referrer" (error)="onLogoError()" />
        <h3 class="club-name">{{ clubName() }}</h3>
      </div>
      <!-- Center section: Empty for spacing -->
      <div class="navbar-center"></div>
      <!-- Right section: Actions -->
      <div class="navbar-right">
        <button
          type="button"
          class="help-toggle-btn"
          (click)="toggleHelpPanel()"
          aria-label="Toggle help panel"
          title="Contextual Help"
        >
          <i class="pi pi-question-circle" aria-hidden="true"></i>
        </button>
        <div class="theme-toggle-wrapper">
          <app-ui-toggle></app-ui-toggle>
          <app-theme-toggle></app-theme-toggle>
        </div>
      </div>
    </div>
  </nav>
}

<!-- Mobile Navigation -->
<app-mobile-nav
  [isOpen]="isMobileNavOpen()"
  [menus]="menus()"
  [parentClubLogo]="parentClubLogo()"
  [clubName]="clubName()"
  [roleType]="roleType()"
  [isSuperUserLoggedIn]="isSuperUserLoggedIn()"
  [isBookingTabActive]="isBookingTabActive()"
  (closeNavigation)="closeMobileNav()"
  (logoutRequested)="logout()"
></app-mobile-nav>

<!-- Ask AP Floating Button -->
<button
  type="button"
  class="ask-ap-fab"
  [class.collapsed]="askApCollapsed()"
  (click)="onActionButtonClick()"
  (mouseenter)="askApCollapsed.set(false)"
  (mouseleave)="collapseAskAp()"
  aria-label="Ask AP"
  title="Ask AP">
  <i class="pi pi-sparkles" aria-hidden="true"></i>
  <span class="ask-ap-label">Ask AP</span>
</button>

<!-- AI Assistant -->
<app-ai-assistant
  [isOpen]="isAiAssistantOpen()"
  (closeAssistant)="closeAiAssistant()"
></app-ai-assistant>

<app-confirm-dialog
  [visible]="showLogoutConfirm()"
  title="Log out"
  message="Are you sure you want to log out?"
  icon="pi pi-sign-out"
  iconColor="var(--success-color)"
  confirmLabel="Log out"
  confirmIcon="pi pi-sign-out"
  confirmColor="primary"
  (confirmed)="performLogout()"
  (cancelled)="showLogoutConfirm.set(false)" />
